import React, { useState, useCallback, useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setAppProperty } from "../../../../../redux/actions";
import {
  validateFullNameErrors,
  validateSINNumberErrors,
  validateEmailErrors,
  validatePhoneNumberErrors,
  validateAltPhoneNumberErrors,
  validateLastNameErrors
} from "../../../../../shared/helpers/validators";
import { initialPersonalInformation } from "../../../../../redux/reducers/appReducer";
import InfoTextFormComponent from "./FormComponents/InfoTextFormComponent";
import SinTextFormComponent from "./FormComponents/SinTextFormComponent";
import DateSelectionForm from "../../../../../shared/components/DateSelectionForm";
import { getApplicantsAge } from "../../../../../helpers/utils";
import { ErrorWithString } from "../../../../../shared/components/RegularComponents";

const REDUX_APP_PROPERTY = "personalInformation";

const OPTION_FALSE = false;
const OPTION_TRUE = true;

const PersonalDetailsForm = ({
  t,
  i18n,
  setValidateForm,
  setIsError,
  language
  // getDateOfBirthFlag
}) => {
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({
    ...initialPersonalInformation
  });

  const { personalInformation } = useSelector((state) => state.app);

  const datesData = useSelector((state) => state.datesReducer);
  let dates, currentLanguageDates;
  if (datesData) {
    dates = datesData["en"];
    currentLanguageDates = datesData[i18n.language];
  }

  // const [ageError, setAgeError] = useState(false);

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [dobFlag, setDobFlag] = useState(false);
  const {
    firstName,
    lastName,
    socialInsuranceNumber,
    dateOfBirth,
    email,
    phone,
    altPhone,
    textAllowedAtPhoneNumber
  } = personalInformation;
  const [dob, setDob] = useState(dateOfBirth);
  const [dobValidCharacter, setDobValidCharacter] = useState("");
  const dobStatusClasses = useMemo(() => {
    if (
      (formErrors.dateOfBirth === null || !formErrors.dateOfBirth) &&
      !dobFlag
    ) {
      return "ns-form-group";
    }
    // else if (!formErrors.dateOfBirth && !dobFlag) {
    //   return "ns-form-group has-success";
    // }
    else {
      return "ns-form-group has-error ns-form-group-message-error";
    }
  }, [formErrors, dobFlag]);

  // const getHumanReadableMonth = (month) => {
  //   switch (month) {
  //     case 0:
  //       return "January";
  //     case 1:
  //       return "February";
  //     case 2:
  //       return "March";
  //     case 3:
  //       return "April";
  //     case 4:
  //       return "May";
  //     case 5:
  //       return "June";
  //     case 6:
  //       return "July";
  //     case 7:
  //       return "August";
  //     case 8:
  //       return "September";
  //     case 9:
  //       return "October";
  //     case 10:
  //       return "November";
  //     case 11:
  //       return "December";
  //     default:
  //       return "";
  //   }
  // };

  // const humanReadableDate = (date) => {
  //   let dateObj = new Date(date);

  //   return `${dateObj.getDate()} ${getHumanReadableMonth(
  //     dateObj.getMonth()
  //   )} ${dateObj.getFullYear()}`;
  // };

  const validateFirstName = (firstName, valid) => {
    try {
      const newPersonalErrors = { ...formErrors };
      if (valid === null) {
        newPersonalErrors.firstName = "";
      } else {
        newPersonalErrors.firstName = validateFullNameErrors(firstName);
      }
      setFormErrors(newPersonalErrors);
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateLastName = (lastName, valid) => {
    try {
      const newPersonalErrors = { ...formErrors };
      if (valid === null) {
        newPersonalErrors.lastName = "";
      } else {
        newPersonalErrors.lastName = validateLastNameErrors(lastName);
      }
      setFormErrors(newPersonalErrors);
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateSIN = (socialInsuranceNumber, valid) => {
    try {
      const newPersonalErrors = { ...formErrors };
      if (valid === null) {
        newPersonalErrors.socialInsuranceNumber = "";
      } else {
        newPersonalErrors.socialInsuranceNumber = validateSINNumberErrors(
          socialInsuranceNumber
        );
      }
      setFormErrors(newPersonalErrors);
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateEmail = (email, valid) => {
    try {
      const newPersonalErrors = { ...formErrors };
      if (valid === null) {
        newPersonalErrors.email = "";
      } else {
        newPersonalErrors.email = validateEmailErrors(email);
      }
      setFormErrors(newPersonalErrors);
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validatePhone = (phone, valid) => {
    try {
      const newPersonalErrors = { ...formErrors };
      if (valid === null) {
        newPersonalErrors.phone = "";
      } else {
        newPersonalErrors.phone = validatePhoneNumberErrors(phone);
      }
      setFormErrors(newPersonalErrors);
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateAltPhone = (altPhone, valid) => {
    try {
      const newPersonalErrors = { ...formErrors };
      if (valid === null) {
        newPersonalErrors.altPhone = "";
      } else {
        newPersonalErrors.altPhone = validateAltPhoneNumberErrors(altPhone);
      }
      setFormErrors(newPersonalErrors);
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const handleSetAppProperty = useCallback(
    (fieldName, value) => {
      const newPersonalInformation = {
        ...personalInformation,
        [fieldName]: value
      };
      dispatch(setAppProperty(REDUX_APP_PROPERTY, newPersonalInformation));
    },
    [dispatch, personalInformation]
  );

  const validateFields = useCallback(() => {
    const newFormErrors = { ...formErrors };
    newFormErrors.firstName = validateFullNameErrors(firstName);
    newFormErrors.lastName = validateLastNameErrors(lastName);
    newFormErrors.socialInsuranceNumber = validateSINNumberErrors(
      socialInsuranceNumber
    );
    newFormErrors.email = validateEmailErrors(email);
    newFormErrors.phone = validatePhoneNumberErrors(phone);
    newFormErrors.altPhone = validateAltPhoneNumberErrors(altPhone);
    const dateOfBirthError = !day || !month || !year;
    if (dateOfBirthError) {
      newFormErrors.dateOfBirth = dateOfBirthError
    }
    if (dob) {
      newFormErrors.ageError =
        getApplicantsAge(dateOfBirth, dates) < 18 || Number(year) < 1900 || Number(day) > 31 || (dobFlag ? true : false);
    }
    if (!dobValidCharacter) {
      newFormErrors.dob = true;
    }
    newFormErrors.textAllowedAtPhoneNumber =
      textAllowedAtPhoneNumber === 0 ||
        textAllowedAtPhoneNumber === null ||
        textAllowedAtPhoneNumber === ""
        ? true
        : false;
    // newFormErrors.anotherPerson = anotherPersonValue === "";
    setFormErrors(() => {
      return { ...newFormErrors };
    });

    const isValid = Object.values(newFormErrors).reduce(
      (prev, currentValue) => prev && !currentValue,
      true
    );

    const isFormClean = Object.values(newFormErrors).reduce(
      (prev, currentValue) => prev || currentValue === "",
      false
    );
    const newMailingAddress = {
      firstName,
      lastName,
      socialInsuranceNumber,
      email,
      phone,
      altPhone
    };

    return !isFormClean && isValid ? newMailingAddress : false;
  }, [
    formErrors,
    firstName,
    lastName,
    socialInsuranceNumber,
    email,
    phone,
    altPhone,
    dateOfBirth,
    dobValidCharacter,
    dobFlag,
    day,
    month,
    year,
    dates,
    textAllowedAtPhoneNumber
  ]);

  useEffect(() => {
    setValidateForm(() => validateFields);
  }, [setValidateForm, validateFields]);

  const getDayAndMonth = (day, month, year) => {
    setDay(day);
    setMonth(month);
    setYear(year);
  };

  useEffect(() => {
    let monthNum = Number(month);
    let dayNum = Number(day);
    let yearNum = Number(year);
    if (!isNaN(dayNum) && !isNaN(yearNum)) {
      setDobValidCharacter(true);
    } else {
      setDobValidCharacter(false);
    }
    if (monthNum === 2 && dayNum === 29 && yearNum % 4 === 0) {
      setDobFlag(false);
    } else if (monthNum === 2 && dayNum > 28 && yearNum % 4 !== 0) {
      setDobFlag(true);
    } else if (monthNum === 4 && dayNum > 30) {
      setDobFlag(true);
    } else if (monthNum === 6 && dayNum > 30) {
      setDobFlag(true);
    } else if (monthNum === 9 && dayNum > 30) {
      setDobFlag(true);
    } else if (monthNum === 11 && dayNum > 30) {
      setDobFlag(true);
    } else {
      setDobFlag(false);
    }
  }, [day, month, year]);
  const taxFiledYear = currentLanguageDates
    ? currentLanguageDates?.taxFiled
    : "#YEAR";

  const nameHelper = t("personal_information.name_helper").replace(
    "#YEAR",
    taxFiledYear
  );

  return (
    <>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <InfoTextFormComponent
            label={t("personal_information.first_name")}
            helperText={nameHelper}
            reduxAppProperty={REDUX_APP_PROPERTY}
            changeObjectPropertyAction={handleSetAppProperty}
            fieldName={"firstName"}
            validate={validateFirstName}
            error={formErrors.firstName}
            isValid={formErrors.firstName === "" ? "" : !formErrors.firstName}
            setIsError={setIsError}
            // value={firstName}
            maxLength={"35"}
          />
          <InfoTextFormComponent
            label={t("personal_information.last_name")}
            helperText={nameHelper}
            reduxAppProperty={REDUX_APP_PROPERTY}
            changeObjectPropertyAction={handleSetAppProperty}
            fieldName={"lastName"}
            validate={validateLastName}
            error={formErrors.lastName}
            isValid={formErrors.lastName === "" ? "" : !formErrors.lastName}
            setIsError={setIsError}
            // value={lastName}
            maxLength={"35"}
          />
          <div style={{ paddingBottom: "1.5em" }}>
            <div className={`${formErrors.dateOfBirth || formErrors.ageError || formErrors.dob ? 'ns-form-group has-error ns-form-group-message-error' : 'ns-form-group '}`}>
              <div className="ns-label-wrapper">
                <label className={"ns-label"}>
                  {t("personal_information.date_of_birth")}
                </label>
              </div>
              <div style={{ marginBottom: ".5em" }} className="ns-hint">
                {t("personal_information.date_of_birth_helper")}
              </div>
              <div style={{ marginBottom: ".5em" }}>
                {(formErrors.dateOfBirth || formErrors.ageError || formErrors.dob) && (
                  <div id="street-address-error" className="help-block-focused">
                    <i
                      aria-label={t("errors.hidden_error_msg")}
                      className="fa fa-exclamation-circle error-indicator errorAlert"
                      aria-hidden="true"
                    />
                    <span className="ns-visually-hidden">
                      {t("errors.hidden_error_msg")}
                    </span>
                    <span style={{ marginLeft: "10px" }}>
                      {formErrors.dateOfBirth
                        ? t("personal_information.date_of_birth_error")
                        : formErrors.ageError
                          ? t("personal_information.age_error")
                          : t("personal_information.date_error")}
                    </span>
                  </div>
                )}

                {/* {dateOfBirth !== null && formErrors.ageError && (
                  <div
                    className="ns-error-message field-validation-error"
                  >
                    <ErrorWithString errorMessage={t('personal_information.age_error')} />
                  </div>
                )}
                {formErrors.dob && (
                  <div id="street-address-error" className="help-block-focused">
                    <i
                      aria-label={t("errors.hidden_error_msg")}
                      className="fa fa-exclamation-circle error-indicator errorAlert"
                      aria-hidden="true"
                    />
                    <span className="ns-visually-hidden">
                      {t("errors.hidden_error_msg")}
                    </span>
                    <span style={{ marginLeft: "10px" }} className="ns-error-message field-validation-error">
                      {t("personal_information.date_error")}
                    </span>
                  </div>
                )} */}
                <DateSelectionForm
                  id={"personal-information-date"}
                  date={dateOfBirth}
                  language={language}
                  getDayAndMonth={getDayAndMonth}
                  onDateChange={(date) => {
                    handleSetAppProperty("dateOfBirth", date);
                    setDob(date);
                    const newPersonalErrors = { ...formErrors };
                    newPersonalErrors.dateOfBirth = date === 0 ? null : false;
                    newPersonalErrors.ageError = null;
                    newPersonalErrors.dob = null;
                    setFormErrors(newPersonalErrors);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12 col-sm-8" style={{ paddingBottom: "1em" }}>
        <SinTextFormComponent
          label={t("personal_information.SIN_Number")}
          reduxAppProperty={REDUX_APP_PROPERTY}
          changeObjectPropertyAction={handleSetAppProperty}
          fieldName={"socialInsuranceNumber"}
          validate={validateSIN}
          error={formErrors?.socialInsuranceNumber}
          isValid={
            formErrors?.socialInsuranceNumber === ""
              ? ""
              : !formErrors?.socialInsuranceNumber
          }
          setIsError={setIsError}
          // value={socialInsuranceNumber}
          maxLength={"11"}
          keypadType="numeric"
        />
      </div>
      <div style={{ paddingBottom: "1.5em" }} className="row">
        <div className="col-xs-12 col-sm-8 col-md-12">
          <div style={{ paddingBottom: "1.5em" }}>
            <InfoTextFormComponent
              label={t("personal_information.email_address")}
              helperText={t("personal_information.email_helper")}
              reduxAppProperty={REDUX_APP_PROPERTY}
              changeObjectPropertyAction={handleSetAppProperty}
              fieldName={"email"}
              validate={validateEmail}
              error={formErrors.email}
              isValid={formErrors.email === "" ? "" : !formErrors.email}
              setIsError={setIsError}
              maxLength={"60"}
              keypadType="email"
            />
          </div>
          <div style={{ paddingBottom: "1.5em" }}>
            <InfoTextFormComponent
              label={t("personal_information.phone_message")}
              helperText={t("personal_information.phone_message_helper")}
              reduxAppProperty={REDUX_APP_PROPERTY}
              changeObjectPropertyAction={handleSetAppProperty}
              fieldName={"phone"}
              validate={validatePhone}
              error={formErrors.phone}
              isValid={formErrors.phone === "" ? "" : !formErrors.phone}
              setIsError={setIsError}
              isPhone
              keypadType="tel"
              maxLength={10}
            />
          </div>
          <div className="ns-label-wrapper">
            <label className={"ns-label"}>
              {t("personal_information.phone_text_at_number")}
            </label>
          </div>
          <div style={{ marginBottom: ".5em" }} className="ns-hint">
            {t("personal_information.phone_text_at_number_helper")}
          </div>
          {formErrors.textAllowedAtPhoneNumber && (
            <div className="ns-form-group has-error ns-form-group-message-error">
              <div id="street-address-error" className="help-block-focused">
                <i
                  aria-label={t("errors.hidden_error_msg")}
                  className="fa fa-exclamation-circle error-indicator errorAlert"
                  aria-hidden="true"
                />
                <span className="ns-visually-hidden">
                  {t("errors.hidden_error_msg")}
                </span>
                <span style={{ marginLeft: "10px" }}>
                  {t("errors.text_number_error")}
                </span>
              </div>
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              className="ns-radios__item"
              onClick={() => {
                handleSetAppProperty("textAllowedAtPhoneNumber", OPTION_TRUE);
                setFormErrors({ ...formErrors, textAllowedAtPhoneNumber: "" });
              }}
            >
              <input
                className="ns-radios__input"
                type="radio"
                id="text-number-yes-radio"
                name="text-number-yes-radio"
                value={OPTION_TRUE}
                onChange={(e) => {
                  handleSetAppProperty("textAllowedAtPhoneNumber", OPTION_TRUE);
                  setFormErrors({ ...formErrors, textAllowedAtPhoneNumber: "" });
                }}
                checked={textAllowedAtPhoneNumber === OPTION_TRUE}
              />
              <label
                className="ns-label ns-radios__label"
                htmlFor="text-number-yes-radio"
              >
                {t("shared.yes")}
              </label>
            </div>
            <div
              style={{ marginLeft: "20px" }}
              className="ns-radios__item"
              onClick={() => {
                // setCanSendTextOnNumber(OPTION_FALSE);
                handleSetAppProperty("textAllowedAtPhoneNumber", OPTION_FALSE);
                setFormErrors({ ...formErrors, textAllowedAtPhoneNumber: "" });
              }}
            >
              <input
                className="ns-radios__input"
                type="radio"
                id="text-number-no-radio"
                name="text-number-no-radio"
                value={OPTION_FALSE}
                onChange={(e) => {
                  handleSetAppProperty(
                    "textAllowedAtPhoneNumber",
                    OPTION_FALSE
                  );
                  setFormErrors({ ...formErrors, textAllowedAtPhoneNumber: "" });
                }}
                checked={textAllowedAtPhoneNumber === OPTION_FALSE}
              />
              <label
                className="ns-label ns-radios__label"
                htmlFor="text-number-no-radio"
              >
                {t("shared.no")}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-8">
          <InfoTextFormComponent
            label={t("personal_information.alt_phone_message")}
            helperText={t("personal_information.alt_phone_message_helper")}
            reduxAppProperty={REDUX_APP_PROPERTY}
            changeObjectPropertyAction={handleSetAppProperty}
            fieldName={"altPhone"}
            validate={validateAltPhone}
            error={formErrors.altPhone}
            isValid={formErrors.altPhone === "" ? "" : !formErrors.altPhone}
            setIsError={setIsError}
            // value={altPhone}
            isPhone
            keypadType="tel"
            maxLength={10}
          />
        </div>
      </div>
    </>
  );
};

export default withTranslation("common")(PersonalDetailsForm);
